/* eslint-disable no-unused-expressions */
/******************************************************************************
 * LocalCache Class
 * version: 1.0.1, release: 07.09.2018
 * author: albert lang, albert@jumptomorrow.com
 * ----------------------------------------------------------------------------
 * description:
 * 
 * dependencies: none
 * 
 * todos:
 * 
 * links:
 * https://github.com/localForage/localForage
 * https://localforage.github.io/localForage/
 *  * 
******************************************************************************/

// import { dialog } from "electron";
import localForage from "localforage";
import { extendPrototype } from 'localforage-getitems';
// import sessionStorageWrapper from "localforage-sessionstoragewrapper";
extendPrototype(localForage);

const version = '1.0.3'
const release = '14.08.2024'

const fs = window.require?.('fs')
const electron = window.require?.('electron')
const dialog = electron?.remote?.dialog


//============================================================================= LocalCache Class
export default class LocalCache {
	static useSessionStorrage = false		//use session storrage

	setTimestamp = false	//set _added and _updated timestamp
	sortKeys = false
	index = {}				//lookuplist of all keys
	session = {}			//session cache. not saved to disk
	onAdd = null			//optional handler if add
	onUpdate = null			//optional handler if update
	onRemove = null			//optional handler if remove
	items = null
	itemList = null
	numLoaded = 0
	keys = null
	// indices = {}
	

	// ------------------------------------------------------------------------ constructor
	constructor(name, id, callback, param){
		this.name = name
		this.id = id || name
		this.param = param

		for (let i in param) this[i] = param[i] 

		console.log('---init localCache for', name, (id || ''), '...')

		this.init(this.name, this.id, callback)
	}


	// ------------------------------------------------------------------------ init
	init(name, id, callback){

		// ---TODO: need to test this first
		// if (LocalCache.useSessionStorrage){
		// 	console.log('---localCache useSessionStorrage!')
		// 	await localForage.defineDriver(sessionStorageWrapper)
		// 	await localForage.setDriver(sessionStorageWrapper._driver)
		// }

		this.store = localForage.createInstance({
			name: name,
			storeName: id
		});

		this.items = {};		//lookup list of all already loaded items
		this.itemList = [];		//list of all already loaded items
		this.numLoaded = 0;		//loaded items count

		this.store.keys()		//list of all existing keys
			.then(keys => {
				this.keys = keys
				keys.sort(function(a, b){return b - a})

				if (this.sortKeys) keys?.sort(function(a, b){return b - a})

				this.index = {}			//lookup list of all item keys
				keys.forEach((k, i) => this.index[k] = i)	//create index lookupList
				this.numItems = keys.length
		
				this.indices = localForage.createInstance({
					name: name,
					storeName: id + '_indices'
				});
				this.indexCache = {}	//cache for all loaded indices
		
				callback?.(this)
			})
			.catch(err => {
				console.error('localCache init error:', err)				
			});
	}


	// ------------------------------------------------------------------------ createIndex
	// check: double index found! 1405300977041694724 1405252033242963974: _likedOrder: 1686857376743
	//
	async createIndex(key, allowNull=true){
		if (!this.keys) return
		
		// let index = this.indices[key] = {}		//create new index for this key
		let index = {}		//create new index for this key
		console.log('create index for', key, this.keys.length, '...')

		let nulls = 0
		for (let id of this.keys){			//load all items
			let item = await this.getItem(id)

			if (item[key]){					//item has the index attribute
				if (index[item[key]]){		//index for this item already exists
					console.error('double index found for key:', key,
						'value:', item[key], 'exists:', index[item[key]], 'new:',id, 'item:',item)
					// return
				}else{
					index[item[key]] = id	//add index
				}
			}else{
				nulls ++
				if (!allowNull){
					console.error('index not found!', item)
					// return
				}
			}
		}
		console.log('index complete!', 'missing indices:', nulls)

		if (!this.indices){
			console.log('---create new index table for', key)
			this.indices = localForage.createInstance({
				name: this.name,
				storeName: this.id + '_indices'
			});
			console.log('ok')
		}

		await this.indices.setItem(key, index)
		console.log('index for', key, 'complete!')

		return index
	}


	// ------------------------------------------------------------------------ addIndex
	async addIndex(key, id, item){
		if (!item[key]) return		//item has no index attribute

		let index = this.indexCache[key]

		if (!index){
			index = await this.indices?.getItem(key)		//create new index for this key
			if (!index) return			//no index for this key

			this.indexCache[key] = index
		}

		if (index[item[key]]){			//index for this item already exists
			console.info('index already exists!', index[item[key]], item)
			return
		}

		index[item[key]] = id		//add new index

		if (index._timeout) clearTimeout(index._timeout)
		index._timeout = setTimeout(async () => {
			await this.indices.setItem(key, index)
			console.log('index for', key, 'updated!')
				
		}, 3000)
	}


	// ------------------------------------------------------------------------ addIndices
	async addIndices(key, items){
		if (!Array.isArray(items) || !items.length) return

		let index = await this.indices?.getItem(key)		//create new index for this key
		if (!index){
			console.log('no index for', key, 'found!')
			return
		}

		///
	}


	// ------------------------------------------------------------------------ getIndex
	async getIndex(key){
		return await this.indices?.getItem(key)
	}


	// ------------------------------------------------------------------------ loadCache
	async loadCache(){
		console.log('---' + this.id + ' load cache of', this.keys.length, 'items ...');
		// this.items = {};
		// this.itemList = [];
		// let now = Date.now()

		for (let id of this.keys){		//load all items
			if (!this.items[id]){
				let item = await this.store.getItem(id);
				this.items[id] = item;
				this.itemList.push(item);
			}
		}

		// await this.store.iterate((item, key) => {
		// 	this.items[key] = item;
		// 	this.itemList.push(item);
		// });

		this.numLoaded = this.itemList.length;
		console.log('   ' + this.id + ' load complete: ' + this.numLoaded + ' items');
		return this.itemList;
	}


	// ------------------------------------------------------------------------ setItem
	async importCache(keyField='id'){
		if (!dialog) return

		const files = await dialog.showOpenDialog({properties: ['openFile']});
		if (files.canceled) return null

		let file = files.filePaths[0].replace(/\\/g, '/')
		console.log('import data from', file, '...')

		let json
		try {
			let data = await fetch(file).catch(err => err)
			json = await data.json().catch(err => err)
		} catch (err) {
			console.error(err)
			return null
		}
		if (!json) return null

		console.log('ok! num items:', Object.keys(json).length)

		// console.log(json)
		let len = Array.isArray(json)? json.length : Object.keys(json).length
		if (window.confirm('Start importing ' + len + ' items?')){
			await this.parseImport(json, keyField)
			return json
	
		}else{
			console.log('canceled')
			return
		}
	}


	// ------------------------------------------------------------------------ parseImport
	async parseImport(json, keyField){
		console.log('parse import ...')
		let stat = {added:0, skiped:0}

		for (let key in json){
			let item = json[key]
			let id = item[keyField] || key

			if (this.items[id]){
				stat.skiped ++
			}else{
				console.log('add', id)
				stat.added ++
				
				await this.setItem(id, item)	//import item
			}
		}

		console.log('stat:', stat)
	}


	
	// ------------------------------------------------------------------------ exportCache
	async exportCache(file){
		if (!file || !fs) return


		console.log('export cache to', file, '...' )
		await this.loadCache()

		console.log('parse', this.itemList.length, '...')

		const limit = 10000

		if (this.itemList.length <= limit){
			let data = JSON.stringify(this.itemList, null, '\t')	//Uncaught (in promise) RangeError: Invalid string length
			fs.writeFileSync(file, data);
			console.log('data exported to', file)

		}else{		//save splited list
			let from = 0
			let to = limit
			let list = this.itemList.slice(from, to)
			let i = 0
			let p = file.lastIndexOf('.')
			let pre = file.substring(0, p)
			let ext = file.substring(p)

			while(list.length){
				file = pre + '_' + i + ext
				let data = JSON.stringify(list, null, '\t')
				fs.writeFileSync(file, data);
				console.log('data exported to', file)

				from += limit
				to += limit
				i ++
				list = this.itemList.slice(from, to)
			}
		}

		console.log('export complete!')
	}


	// ------------------------------------------------------------------------ updateItem
	// update existing item
	async updateItem(item, altId){
		if (!item) return

		let id = altId || item.id
		if (id === undefined || id === null){
			return console.error('item has no id to save:', item)
		} 
		this.onUpdate?.(item)		//update only
		await this.store.setItem(id, item);		//add or update
		return item;
	}


	// ------------------------------------------------------------------------ setItem
	async setItem(id, item, override=true, addIndex=null){
		if (!id) return

		let exists = this.exists(id)
		if (exists && !override) return this.items[id]

		if (exists){
			if (typeof item === 'object' && this.setTimestamp) item._updated = Date.now()
			this.items[id] = item		//replace existing item
			this.itemList[this.itemList.indexOf(item)] = item	//replace from list
			this.onUpdate?.(item)		//update only

		}else{		//add new
			this.index[id] = this.keys.length
			this.keys.push(id)

			if (typeof item === 'object' && this.setTimestamp) item._added = Date.now()
			this.onAdd?.(item)
			this.items[id] = item		//add new item
			this.itemList.push(item)	//append to list
			this.numLoaded = this.itemList.length;
		}

		await this.store.setItem(id, item);		//add or update

		if (addIndex) await this.addIndex(addIndex, id, item)

		return item;
	}


	// ------------------------------------------------------------------------ setItems
	async setItems(list, override=true){
		if (!list) return;

		for (let e in list){
			await this.setItem(e, list[e], override);
		}
	}

		
	// ------------------------------------------------------------------------ exists
	exists(id){
		return this.index[id] !== undefined
	}


	// ------------------------------------------------------------------------ getItemAsync
	_getQueue = []
	getItemAsync(id, callback){
		if (this.items[id]) return this.items[id];		//already loaded

		if (!this._isLoading){
			this._isLoading = true
			this.getNextItem(id, callback)

		}else{
			this._getQueue.push([id, callback])			//add new item at the end of the list
		}
	}
	getNextItem(id, callback){
		if (!id) [id, callback] = this._getQueue.pop()	//get last (newest) elemenet from queue

		if (this.items[id]){				//already loaded
			callback?.(this.items[id]);
			if (this._getQueue.length) this.getNextItem()
			else{
				this._isLoading = false
				// console.log('---queue complete')
			}
			return
		}

		this.store.getItem(id).then(item => {
			this.items[id] = item;
			this.itemList.push(item);
			this.numLoaded = this.itemList.length;
			callback?.(item)

			if (this._getQueue.length) this.getNextItem()
			else{
				this._isLoading = false
				// console.log('---queue complete')
			}
		})
	}
	clearItem(id){
		if (!this._getQueue.length || this.items[id]) return
		this._getQueue.splice(this._getQueue.indexOf(id), 1)	//remove item from queu
	}


	// ------------------------------------------------------------------------ getItem
	async getItem(id){
		if (this.items[id]) return this.items[id];		//already loaded

		let item = await this.store.getItem(id);
		this.items[id] = item;
		this.itemList.push(item);
		this.numLoaded = this.itemList.length;
		return item;
	}


	// ------------------------------------------------------------------------ getItems
	async getItems(list){
		if (!list) return this.items;

		let result = [];
		for (let e in list){
			let item = await this.getItem(e);
			result.push(item);
		}
		return result;
	}


	// ------------------------------------------------------------------------ forEachItem
	async forEachItem(callback){
		if (!callback) return

		let i = 0
		for (let id of this.keys){		//load all items
			let item = await this.getItem(id);
			await callback(item, i++)
		}
	}


	// ------------------------------------------------------------------------ removeItem
	async removeItem(id){
		if (!this.exists(id)) return

		let item = this.items[id]
		
		this.onRemove?.(item)
		delete this.index[id]
		delete this.items[id]

		this.itemList.splice(this.itemList.indexOf(item))
		this.numLoaded = this.itemList.length

		let result = await this.store.removeItem(id)
		this.keys = await this.store.keys()				//update keys
		this.numItems = this.keys.length

		return result;
	}


	// ------------------------------------------------------------------------ clear
	async clear(){
		this.index = {}
		this.items = {}
		this.itemList = []
		this.keys = []
		this.numItems = 0
		this.numLoaded = 0

		let result = await this.store.clear();
		return result;
	}


	// ------------------------------------------------------------------------ getItemList
	getItemList(){
		return this.itemList;
	}
}
